/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_SubmittingInputs */

const en_site_submitting = /** @type {(inputs: Site_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing…`)
};

const id_site_submitting = /** @type {(inputs: Site_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyiapkan…`)
};

/**
* | output |
* | --- |
* | "Preparing…" |
*
* @param {Site_SubmittingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_submitting = /** @type {((inputs?: Site_SubmittingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_SubmittingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_submitting(inputs)
	return en_site_submitting(inputs)
});